import { inject } from '@angular/core';
import { of } from 'rxjs';
import { findToolStartCommand, Interceptor, PromptResponse } from '@panaya/ai-chat/domain';
import { AiChatThinkingService } from './ai-chat-thinking.service';

export function createScriptBuilderThinkingInterceptor(): Interceptor<PromptResponse> {
    const service = inject(AiChatThinkingService);
    return (response: PromptResponse) => {
        const names = ['mcp__script_builder__convert_text_to_test', 'mcp__script_builder__load_migrated_test'];
        const command = findToolStartCommand(response.commands, (name) => names.includes(name));
        if (command) {
            service.notifyThinkingEvent({ state: 'working', translationKey: 'aichat.thinking.tools.convert_text_to_test' });
        }
        return of(response);
    };
}
